import { LegalHeader } from "../components/landing/LegalHeader";
import { LandingFooter } from "../components/landing/LandingFooter";

export default function DatenschutzPage() {
  const S = "font-semibold text-gray-900 text-lg md:text-xl mb-4";
  const S3 = "font-medium text-gray-900 text-base mb-2 mt-6";
  return (
    <div className="min-h-screen font-['Inter',system-ui,sans-serif] bg-white">
      <LegalHeader />

      <main className="pt-36 md:pt-44 pb-24 md:pb-32" data-testid="datenschutz-content">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">

            <h1 className="font-bold text-gray-900 text-3xl md:text-4xl lg:text-5xl tracking-tight mb-12 md:mb-16">
              Datenschutzerklärung
            </h1>

            <div className="space-y-10 md:space-y-12 text-gray-500 text-[15px] leading-relaxed">

              {/* 1. Verantwortlicher */}
              <section>
                <h2 className={S}>1. Verantwortlicher</h2>
                <p>Verantwortlich im Sinne der Datenschutz-Grundverordnung (DSGVO) und anderer nationaler Datenschutzgesetze sowie sonstiger datenschutzrechtlicher Bestimmungen ist:</p>
                <div className="mt-4 space-y-1">
                  <p className="font-medium text-gray-900">TGAone OHG</p>
                  <p>Ronny Pforr, Florian Trautmann</p>
                  <p>Dammersbacher Strasse 7</p>
                  <p>36088 Hünfeld</p>
                  <p>Deutschland</p>
                  <p className="mt-3">
                    Telefon: <a href="tel:+491784061676" className="text-gray-900 hover:underline">+49 178 4061676</a>
                    {" / "}
                    <a href="tel:+491723023898" className="text-gray-900 hover:underline">+49 172 3023898</a>
                  </p>
                  <p>E-Mail: <a href="mailto:info@tgaone.de" className="text-gray-900 hover:underline">info@tgaone.de</a></p>
                </div>
              </section>

              {/* 2. Allgemeine Hinweise */}
              <section>
                <h2 className={S}>2. Allgemeine Hinweise zur Datenverarbeitung</h2>
                <p>
                  Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt stets im Einklang mit der Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG).
                </p>

                <h3 className={S3}>Rechtsgrundlagen</h3>
                <p>Die Verarbeitung personenbezogener Daten erfolgt auf Basis folgender Rechtsgrundlagen:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li><span className="text-gray-700">Art. 6 Abs. 1 lit. a DSGVO</span> – Einwilligung der betroffenen Person</li>
                  <li><span className="text-gray-700">Art. 6 Abs. 1 lit. b DSGVO</span> – Erfüllung eines Vertrags oder vorvertraglicher Massnahmen</li>
                  <li><span className="text-gray-700">Art. 6 Abs. 1 lit. c DSGVO</span> – Erfüllung einer rechtlichen Verpflichtung</li>
                  <li><span className="text-gray-700">Art. 6 Abs. 1 lit. f DSGVO</span> – Wahrung berechtigter Interessen</li>
                </ul>

                <h3 className={S3}>Zweckbindung und Datensparsamkeit</h3>
                <p>
                  Wir erheben personenbezogene Daten ausschliesslich für festgelegte, eindeutige und legitime Zwecke. Eine Verarbeitung zu anderen Zwecken findet nicht statt. Wir beschränken die Datenerhebung auf das für den jeweiligen Zweck erforderliche Minimum.
                </p>
              </section>

              {/* 3. Server-Log-Dateien */}
              <section>
                <h2 className={S}>3. Server-Log-Dateien</h2>
                <p>
                  Beim Zugriff auf diese Website werden durch den Hostingprovider automatisch Informationen in Server-Log-Dateien erfasst, die Ihr Browser übermittelt. Dies umfasst:
                </p>
                <ul className="list-disc list-inside mt-3 space-y-1">
                  <li>IP-Adresse des anfragenden Rechners</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                  <li>Name und URL der abgerufenen Datei</li>
                  <li>Referrer-URL (zuvor besuchte Seite)</li>
                  <li>Verwendeter Browser und Betriebssystem</li>
                  <li>Hostname des zugreifenden Rechners</li>
                </ul>
                <p className="mt-4">
                  <span className="text-gray-700">Rechtsgrundlage:</span> Art. 6 Abs. 1 lit. f DSGVO. Die Erfassung dieser Daten ist zur Bereitstellung und Sicherstellung des Betriebs der Website technisch erforderlich. Ein berechtigtes Interesse besteht insbesondere in der Gewährleistung der Systemsicherheit und der Erkennung von Missbrauch.
                </p>
                <p className="mt-3">
                  <span className="text-gray-700">Speicherdauer:</span> Die Server-Log-Dateien werden nach spätestens 14 Tagen automatisch gelöscht, sofern keine weitergehende Aufbewahrung zu Beweiszwecken erforderlich ist.
                </p>
                <p className="mt-3">
                  Eine Zusammenführung dieser Daten mit anderen Datenquellen findet nicht statt.
                </p>
              </section>

              {/* 4. Kontaktformular */}
              <section>
                <h2 className={S}>4. Kontaktformular</h2>
                <p>
                  Wenn Sie uns über das auf der Website bereitgestellte Kontaktformular eine Nachricht senden, werden die folgenden Daten verarbeitet:
                </p>
                <ul className="list-disc list-inside mt-3 space-y-1">
                  <li>Name</li>
                  <li>E-Mail-Adresse</li>
                  <li>Telefonnummer (sofern angegeben)</li>
                  <li>Unternehmen (sofern angegeben)</li>
                  <li>Inhalt Ihrer Nachricht</li>
                </ul>
                <p className="mt-4">
                  <span className="text-gray-700">Zweck:</span> Die Verarbeitung erfolgt ausschliesslich zur Bearbeitung Ihrer Anfrage und zur Kontaktaufnahme im Rahmen einer möglichen Geschäftsbeziehung.
                </p>
                <p className="mt-3">
                  <span className="text-gray-700">Rechtsgrundlage:</span> Art. 6 Abs. 1 lit. b DSGVO (Durchführung vorvertraglicher Massnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).
                </p>
                <p className="mt-3">
                  <span className="text-gray-700">Speicherdauer:</span> Die im Kontaktformular übermittelten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt. Zwingende gesetzliche Aufbewahrungsfristen bleiben unberührt.
                </p>
                <p className="mt-3">
                  Eine Weitergabe der Daten an Dritte erfolgt nicht.
                </p>
              </section>

              {/* 5. Keine Analyse- oder Marketing-Tools */}
              <section>
                <h2 className={S}>5. Analyse- und Marketing-Tools</h2>
                <p>
                  Auf dieser Website werden <span className="text-gray-700 font-medium">keine Analyse-, Tracking- oder Marketing-Tools</span> eingesetzt. Im Einzelnen bedeutet dies:
                </p>
                <ul className="list-disc list-inside mt-3 space-y-1">
                  <li>Kein Google Analytics oder vergleichbare Analysedienste</li>
                  <li>Kein Meta-Pixel oder sonstige Werbetracker</li>
                  <li>Keine Weitergabe von Nutzerdaten an Dritte zu Werbezwecken</li>
                  <li>Keine Profilbildung oder verhaltensbasierte Auswertung</li>
                  <li>Keine extern eingebundenen Medien oder Ressourcen, die eine Datenübermittlung an Dritte auslösen</li>
                </ul>
                <p className="mt-4">
                  Eine Auswertung Ihres Nutzungsverhaltens findet nicht statt. Ihre Daten werden zu keinem Zeitpunkt für Werbezwecke verwendet oder an Werbetreibende übermittelt.
                </p>
              </section>

              {/* 6. Cookies */}
              <section>
                <h2 className={S}>6. Cookies</h2>
                <p>
                  Diese Website verwendet ausschliesslich <span className="text-gray-700 font-medium">technisch notwendige Cookies</span>, die für den ordnungsgemässen Betrieb der Website erforderlich sind. Dazu gehören insbesondere Cookies zur Aufrechterhaltung der Benutzersitzung (Session-Cookies) und zur Speicherung technischer Einstellungen.
                </p>
                <p className="mt-4">
                  Technisch notwendige Cookies werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gesetzt. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Bereitstellung seiner Dienste.
                </p>
                <p className="mt-4">
                  <span className="text-gray-700">Analyse-Cookies, Marketing-Cookies oder Cookies von Drittanbietern werden nicht eingesetzt.</span> Eine gesonderte Einwilligung (Cookie-Banner) ist daher nicht erforderlich.
                </p>
              </section>

              {/* 7. SSL/TLS */}
              <section>
                <h2 className={S}>7. SSL- bzw. TLS-Verschlüsselung</h2>
                <p>
                  Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung personenbezogener Daten eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an dem Präfix „https://" in der Adresszeile Ihres Browsers sowie am Schloss-Symbol.
                </p>
                <p className="mt-4">
                  Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
                </p>
              </section>

              {/* 8. Rechte der betroffenen Personen */}
              <section>
                <h2 className={S}>8. Rechte der betroffenen Personen</h2>
                <p>
                  Ihnen stehen im Zusammenhang mit der Verarbeitung Ihrer personenbezogenen Daten folgende Rechte zu:
                </p>

                <h3 className={S3}>Recht auf Auskunft (Art. 15 DSGVO)</h3>
                <p>Sie haben das Recht, Auskunft über die von uns verarbeiteten personenbezogenen Daten zu verlangen.</p>

                <h3 className={S3}>Recht auf Berichtigung (Art. 16 DSGVO)</h3>
                <p>Sie haben das Recht, die unverzügliche Berichtigung unrichtiger oder die Vervollständigung unvollständiger personenbezogener Daten zu verlangen.</p>

                <h3 className={S3}>Recht auf Löschung (Art. 17 DSGVO)</h3>
                <p>Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</p>

                <h3 className={S3}>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</h3>
                <p>Sie haben das Recht, unter bestimmten Voraussetzungen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</p>

                <h3 className={S3}>Recht auf Widerspruch (Art. 21 DSGVO)</h3>
                <p>Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen, sofern die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO beruht.</p>

                <h3 className={S3}>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</h3>
                <p>Sie haben das Recht, die Sie betreffenden Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen.</p>

                <h3 className={S3}>Beschwerderecht bei einer Aufsichtsbehörde</h3>
                <p>
                  Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Datenschutzaufsichtsbehörde zu. Die für uns zuständige Aufsichtsbehörde ist:
                </p>
                <div className="mt-3 space-y-1">
                  <p className="text-gray-700">Der Hessische Beauftragte für Datenschutz und Informationsfreiheit</p>
                  <p>Postfach 3163, 65021 Wiesbaden</p>
                  <p>Telefon: +49 611 1408-0</p>
                  <p>E-Mail: poststelle@datenschutz.hessen.de</p>
                </div>
              </section>

              {/* 9. Widerspruch Werbe-Mails */}
              <section>
                <h2 className={S}>9. Widerspruch gegen Werbe-E-Mails</h2>
                <p>
                  Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Website behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen vor.
                </p>
              </section>

              <div className="pt-8 border-t border-gray-100">
                <p className="text-xs text-gray-400">Stand: März 2026</p>
                <p className="text-xs text-gray-400 mt-1">Änderungen dieser Datenschutzerklärung behalten wir uns vor.</p>
              </div>

            </div>
          </div>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
}
